import { AbstractCommand } from 'src/models/command';

class SendAndMemorizeMessage extends AbstractCommand {
	readonly name = 'IFS_Desktop_Command_Command_Legacy_Modules_Message_SendAndMemorizeMessage';

	public constructor(
		aggregateId: string,
		aggregateVersion: number,
		authenticatedUserId: number,
		communicationPartnerUserId: number,
		messageContent: string
	) {
		super();
		this.parameters = {
			aggregateId: aggregateId,
			aggregateVersion: aggregateVersion,
			authenticatedUserId: authenticatedUserId,
			communicationPartnerUserId: communicationPartnerUserId,
			messageContent: messageContent,
		};
	}
}

export { SendAndMemorizeMessage };
